import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/customers/playersAggregator/filter'; // Importing Filter component
import Table from 'views/customers/playersAggregator/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PlayersListView class extends JetView to create a view for players list.
 */
export default class PlayersListView extends JetView {
    /**
     * Configures the UI components of the PlayersListView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const right = {
            // Right section configuration (currently empty)
            type: 'wide',
            rows: [],
        };

        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                // Columns in the toolbar
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size from configuration
                },
            ],
        };

        const left = {
            // Left section configuration
            rows: [
                // Rows in the left section
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying the current theme
                    elements: [
                        // Elements in the toolbar
                        {
                            view: 'label', // Label component
                            label: _('Lista de Jugadores Aggregator'), // Translated label text
                            align: 'center', // Center alignment
                        },
                    ],
                },
                Filter, // Including the Filter component
                Table, // Including the Table component
                toolbar, // Including the toolbar
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        return {
            // Returning the main configuration object
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: true, // Enabling scroll
            responsive: true, // Making the form responsive
            cols: [left], // Columns containing the left section
        };
    }
}

// FILE DOCUMENTED
